import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Fragment } from 'react';
import TruncateMarkup from 'react-truncate-markup';
import { propFunc, propNumber, propShape, } from '../../../../../../../../helpers/custom-prop-types';
const RfpOneDescriptionTabContentText = (props) => {
    const { lines, onTruncate, tabIndex, viewRequest: { offer: { confirm_comment: confirmComment, free_description: freeDescription, good_point_comment: goodPointComment, summary, }, }, } = props;
    const WrapComponent = lines > 0 ? TruncateMarkup : Fragment;
    const addProps = lines > 0 ? { lines, onTruncate } : {};
    if (tabIndex === 1) {
        return (_jsx(WrapComponent, Object.assign({}, addProps, { children: _jsxs("div", { children: [_jsx("span", { children: `${summary}${freeDescription ? '\n\n' : ''}` }), freeDescription ? (_jsxs(_Fragment, { children: [_jsx("span", Object.assign({ className: 'other_title' }, { children: "\u305D\u306E\u4ED6\u306E\u8AAC\u660E" })), _jsx("span", { children: `\n${freeDescription}` })] })) : ('')] }) })));
    }
    if (tabIndex === 2) {
        return (_jsx(WrapComponent, Object.assign({}, addProps, { children: _jsxs("div", { children: [goodPointComment ? (_jsxs(_Fragment, { children: [_jsx("span", Object.assign({ className: 'proffit_title' }, { children: "\u3053\u306E\u63D0\u6848\u306E\u826F\u3044\u30DD\u30A4\u30F3\u30C8" })), _jsx("span", Object.assign({ className: 'proffit_value' }, { children: `\n${goodPointComment}${goodPointComment ? '\n\n' : ''}` }))] })) : (''), confirmComment ? (_jsxs(_Fragment, { children: [_jsx("span", Object.assign({ className: 'proffit_title' }, { children: "\u9762\u8AC7\u3067\u306E\u78BA\u8A8D\u30DD\u30A4\u30F3\u30C8" })), _jsx("span", Object.assign({ className: 'proffit_value' }, { children: `\n${confirmComment}` }))] })) : ('')] }) })));
    }
    return null;
};
RfpOneDescriptionTabContentText.propTypes = {
    lines: propNumber().isRequired,
    onTruncate: propFunc(),
    tabIndex: propNumber().isRequired,
    viewRequest: propShape().isRequired,
};
RfpOneDescriptionTabContentText.defaultProps = {
    onTruncate: undefined,
};
export default RfpOneDescriptionTabContentText;
